// client/utils/token-to-cookie.js
import { cookieUtils } from "./cookie-parser";

/**
 * Store a minimal-but-useful "auth" cookie that your UI can read
 * (and keep the raw JWT in auth_token cookie which the server verifies).
 *
 * NOTE: We intentionally KEEP first_name, last_name, user_type, email here
 * so components that read from cookie or LS never see "undefined".
 */
export const tokenToCookie = function (userObject, reload) {
  try {
    if (!userObject) return;

    // Build the minimal cookie your UI needs
    const minimal = {
      token: userObject.token || "",

      // IDs & type
      user_id: userObject.user_id,
      user_type: userObject.user_type ?? userObject.userType ?? "",

      // Names/emails used by the header/UI
      email: userObject.email || "",
      first_name: userObject.first_name || "",
      last_name: userObject.last_name || "",
      parent_email: userObject.parent_email || "",
      parent_email2: userObject.parent_email2 || "",
    };

    // Persist cookie ~200 days
    const isHttps =
      typeof window.location !== "undefined" && window.location.protocol === "https:";
    cookieUtils.setCookie(
      "auth",
      JSON.stringify(minimal),
      200,
      "/",
      null,
      isHttps,
      "Lax"
    );

    // Also mirror to localStorage for components that read LS
    try {
      localStorage.setItem("auth", "1");
      if (minimal.token) localStorage.setItem("token", minimal.token);
      localStorage.setItem("user_type", minimal.user_type || "");
      localStorage.setItem("first_name", minimal.first_name || "");
      localStorage.setItem("last_name", minimal.last_name || "");
      // If you keep a full user object in LS, store it too when available
      if (userObject) {
        const clone = { ...userObject };
        delete clone.password;
        localStorage.setItem("user", JSON.stringify(clone));
        localStorage.setItem("userData", JSON.stringify(clone));
      }
    } catch (e) {
      // ignore LS failures
    }

    if (reload) {
      window.location.reload();
    }
  } catch (e) {
    // swallow
  }
};

export const removeToken = function () {
  cookieUtils.eraseCookie("auth");
  try {
    localStorage.removeItem("auth");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userData");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("user_type");
  } catch { }
};
